module.exports = __webpack_public_path__ + "img/backarrow.282b6891.png";